import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Company} from '../../../models/company';
import {User} from '../../../models/user';
import {isCompanyPendingApproval} from '../shared/company-status';
import {CompanyLegalDocumentField} from './legal/companies-settings-legal.component';

@Component({
    selector: 'app-companies-settings-general',
    templateUrl: './companies-settings-general.component.html',
    styles: [':host { display: block; }']
})
export class CompaniesSettingsGeneralComponent {
    @Input() company: Company = new Company();
    @Input() companyRaw: Record<string, unknown> | null = null;
    @Input() provinces: { id: string; name: string }[] = [];
    @Input() cities: string[] = [];
    @Input() legalCities: string[] = [];
    @Input() agents: User[] = [];
    @Input() teamUsers: User[] = [];
    @Input() hasGlobalVisibility = false;
    @Input() companyHasShop = false;
    @Input() isSuperAdmin = false;
    @Input() canEditPaymentMethod = true;
    @Input() saving = false;
    @Input() approving = false;
    @Input() rulesUrl = '';
    @Input() signatureUrl = '';
    @Input() uploadingFields: Partial<Record<CompanyLegalDocumentField, boolean>> = {};

    @Output() save = new EventEmitter<void>();
    @Output() approve = new EventEmitter<void>();
    @Output() refuse = new EventEmitter<void>();
    @Output() provinceChange = new EventEmitter<void>();
    @Output() legalProvinceChange = new EventEmitter<void>();
    @Output() rulesChange = new EventEmitter<Event>();
    @Output() signatureChange = new EventEmitter<Event>();
    @Output() legalDocumentChange = new EventEmitter<{ field: CompanyLegalDocumentField; event: Event }>();
    @Output() copyValue = new EventEmitter<string>();
    @Output() logoChange = new EventEmitter<Event>();

    get isPendingApproval(): boolean {
        return isCompanyPendingApproval(this.company.status);
    }

    get canApprove(): boolean {
        return !!this.company.domain && !this.approving;
    }
}
